import styled from "styled-components";

export const AlertCard = styled.div<{ heightOffset?: number }>`
  .Toastify__toast-body {
    align-items: flex-start;
  }

  .Toastify__close-button {
    overflow: unset;
  }

  .Toastify__progress-bar {
    background: #57585a !important;
  }

  .Toastify__toast-body {
    padding: 6px 2px;
  }

  .Toastify__toast-container {
    ${({ theme }) => (theme.isDesktop ? "width: 1200px" : "")};
    ${({ theme }) => (theme.isMobile ? "padding: 8px" : "")}
  }

  .Toastify__toast-theme--dark {
    border-radius: 8px;
  }
`;
